/* eslint complexity: ["error", 5], max-params: ["error", 4], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

var trackingUtils = require('../utils/tracking.utils');
var reCaptchaManager = require('../../modules/users/recaptcha.js');
var TRACKING_LABEL = {
    copyLinkSelect: 'share_link_copy_ctrlC',
    copyLinkClick: 'share_link_copy_CTA',
    emailValidation: Odigeo._.template('share_email_<%= type %>'),
    emailSent: Odigeo._.template('<%= labelFunnel %>_<%= labelSent %>'),
    openLauncher: 'share_click',
};
var TEMPLATE_LIST = {
    shareOptions: '.share_options',
    link: '.share_link',
    email: '.share_email',
    shareSocialLinks: '.share_social_links',
    shareDeeplink: '.share_deeplink',
};
var TRANSITION = {
    openLayer: {
        className: 'active',
        delay: 200,
    },
    loading: {
        className: 'loading',
        delay: 1000,
    },
    finish: {
        className: 'finish',
        delay: 3000,
    },
    error: {
        className: 'finish error',
        delay: 4000,
    },
};

function toggleView(hasOpen) {
    this.$cachedSelectors.wrapper.toggleClass('open', hasOpen);
}

function getRenderData() {
    return Odigeo._.defaults({
        shareLinksTemplate: this.templates[this.model.get('shareLinksTemplate')],
    }, this.model.toJSON());
}

function openView(type) {
    var html = this.templates[type](getRenderData.call(this));

    this.$cachedSelectors.wrapper.html(html);
    toggleView.call(this, true);
}

function resetEmail() {
    this.model.reset(Odigeo._.extend(this.model.toJSON(), {
        defaultPassenger: this.$cachedSelectors.inputName.val(),
        emailReceiver: this.$cachedSelectors.inputEmail.val(),
        emailComment: this.$cachedSelectors.inputComment.val(),
    }));
}

function animateShareSelection($el, activeClass, delay, isActive) {
    return $el.toggleClass(activeClass, isActive).delay(delay).promise();
}

function toggleOpenView(isActive) {
    return animateShareSelection(this.$shareSelectionEl, TRANSITION.openLayer.className, TRANSITION.openLayer.delay, isActive);
}

function toggleLoading() {
    return animateShareSelection(this.$el.find(this.slctrs.content), TRANSITION.loading.className, TRANSITION.loading.delay, true);
}

function showConfirmationAndClose() {
    return animateShareSelection(this.$el.find(this.slctrs.content), TRANSITION.finish.className, TRANSITION.finish.delay, true)
        .then(Odigeo._.bind(toggleView, this, false));
}

function showErrorAndOpenEmail() {
    return animateShareSelection(this.$el.find(this.slctrs.content), TRANSITION.error.className, TRANSITION.error.delay, true)
        .then(Odigeo._.bind(resetEmail, this));
}

function finishShareSelection() {
    toggleLoading.call(this).then(Odigeo._.bind(showConfirmationAndClose, this));
}

function disableActions() {
    this.$el.find(this.slctrs.actionButton).addClass('disabled');
}

function copyToClipboard() {
    Odigeo.Utils.copyToClipboard(this.$el.find(this.slctrs.deepLink));
}

function setInvalidInput(hasErrors) {
    $(this).parent().toggleClass('invalid', hasErrors);
}

function bindInputValidation() {
    this.$el.find(this.slctrs.inputValidation)
        .on('blur', Odigeo._.partial(setInvalidInput, false))
        .on('blur', Odigeo._.method('currentTarget.checkValidity'))
        .on('invalid', Odigeo._.partial(setInvalidInput, true));
}

function checkFormValidation() {
    return Odigeo._.every(this.$el.find(this.slctrs.form).get(0).elements, Odigeo._.method('checkValidity'));
}

function getEmailParams() {
    return {
        captchaResponse: this.model.get('reCaptchaResponse'),
        to: [this.$cachedSelectors.inputEmail.val()],
        templateId: this.model.get('templateId'),
        parameters: Odigeo._.extend(this.model.get('emailTemplateParams'), {
            comment: this.$cachedSelectors.inputComment.val(),
            from: this.$cachedSelectors.inputName.val(),
        }),
    };
}

function onOpenLauncher(evt) {
    this.setShareSelectionEl(evt.currentTarget);
    this.model.reset(this.opts);
    this.trackEvent(TRACKING_LABEL.openLauncher);
}

module.exports = Odigeo.View.extend({
    templates: {},
    opts: {},
    $shareSelectionEl: null,
    trackEvent: null,

    events: {
        'click .link_share_selection:not(.disabled)': 'copyShareSelection',
        'select .share_selection_input_deeplink': 'trackEventOnUserSelection',
        'click .email_share_selection:not(.disabled)': 'checkCaptcha',
        'click .select_share_selection': 'openShareSelection',
        'click .select_social_network': 'closeShareSelection',
        'click .share_selection_box': Odigeo._.method('stopPropagation'),
        'click @wrapper': 'closeShareSelection',
        'click .close_share_selection': 'closeShareSelection',
        'focus .prisma-input': 'onFocusInput',
        'blur .prisma-input': 'onBlurInput',
    },

    selectors: {
        wrapper: '.share_selection_wrapper',
        inputEmail: '.share_selection_input_email',
        inputName: '.share_selection_input_name',
        inputComment: '.share_selection_input_text',
        captchaWrapper: '.captcha_wrapper',
    },

    slctrs: {
        box: '.share_selection_box',
        content: '.share_selection_content',
        actionButton: '.share_selection_action',
        deepLink: '.share_selection_input_deeplink',
        form: '#shareSelectionForm',
        inputValidation: '.share_selection_input_email,.share_selection_input_name',
    },

    trackEventOnUserSelection: Odigeo._.once(function() {
        if (!this.$el.find(this.slctrs.actionButton).hasClass('disabled')) {
            this.trackEvent(TRACKING_LABEL.copyLinkSelect);
        }
    }),

    init: function() {
        this.opts = Odigeo.parseOptions(this.widget.options);
        this.trackEvent = Odigeo._.bind(trackingUtils.trackEvent, trackingUtils, this.opts.trackingAction);
        this.templates = Odigeo.Utils.getTemplates(this.$el, TEMPLATE_LIST);
        this.on('after_render_email', Odigeo._.bind(bindInputValidation, this));
        this.listenTo(this.model, 'emailSent', this.onEmailSent);
        this.listenTo(this.model, 'emailSentError', this.onEmailSentError);
        this.listenTo(this.model, 'resetShare', this.render);
    },

    render: function() {
        var templateView = this.$shareSelectionEl.data('templateView');

        return toggleOpenView.call(this, true)
            .then(Odigeo._.bind(openView, this, templateView))
            .then(Odigeo._.bind(this.updateDomSelectorsToCache, this))
            .then(Odigeo._.bind(this.trigger, this, 'after_render_' + templateView))
            .then(Odigeo._.bind(toggleOpenView, this, false))
            .then(Odigeo._.bind(this.initOrRenderCaptcha, this));
    },

    initOrRenderCaptcha: function() {
        var captchaEnabled = this.model.get('captchaEnabled');
        this.model.set('captchaEnabledWithInit', !captchaEnabled);
        if (captchaEnabled) {
            this.widget.enableCaptcha();
        } else {
            reCaptchaManager.init();
            this.model.set('captchaEnabled', true);
        }
    },

    copyShareSelection: function() {
        disableActions.call(this);
        finishShareSelection.call(this);
        copyToClipboard.call(this);
        this.trackEvent(TRACKING_LABEL.copyLinkClick);
    },

    onEmailSent: function() {
        showConfirmationAndClose.call(this);
        this.trackEvent(TRACKING_LABEL.emailSent({
            labelFunnel: this.opts.trackingLabelSentEmail,
            labelSent: 'successful',
        }));
    },

    onEmailSentError: function() {
        if (this.opts.hasErrorConfirmation) {
            showErrorAndOpenEmail.call(this);
        } else {
            toggleView.call(this, false);
        }

        this.trackEvent(TRACKING_LABEL.emailSent({
            labelFunnel: this.opts.trackingLabelSentEmail,
            labelSent: 'unsuccessful',
        }));
    },

    sendEmailShareSelection: function() {
        disableActions.call(this);
        toggleLoading.call(this);
        this.model.sendLinkByEmail(getEmailParams.call(this));

        this.trackEvent(TRACKING_LABEL.emailValidation({type: 'sent'}));
    },

    checkCaptcha: function() {
        if (checkFormValidation.call(this)) {
            reCaptchaManager.gRecaptchaExecute(this.model.get('reCaptchaWidgetId'));
        } else {
            this.trackEvent(TRACKING_LABEL.emailValidation({type: 'error'}));
        }
    },

    reCaptchaExecutionCallback: function() {
        var reCaptchaWidgetId = this.model.get('reCaptchaWidgetId');
        this.model.set('reCaptchaResponse', reCaptchaManager.gRecaptchaGetResponse(reCaptchaWidgetId));
        this.resetReCaptcha(reCaptchaWidgetId);
        this.sendEmailShareSelection();
    },

    resetReCaptcha: function(reCaptchaWidgetId) {
        this.$cachedSelectors.captchaWrapper.addClass('odf-hidden');
        if (reCaptchaWidgetId) {
            reCaptchaManager.gRecaptchaReset(reCaptchaWidgetId);
        }
        this.model.set('reCaptchaWidgetId', '');
    },

    setShareSelectionEl: function(el) {
        this.$shareSelectionEl = $(el);
    },

    openShareSelection: function(evt) {
        this.setShareSelectionEl(evt.currentTarget);
        this.trackEvent(this.$shareSelectionEl.data('trackEventLabel'));
        Odigeo.trigger(this.widget.id + ':onUpdateShareSelection');
    },

    onBlurInput(evt) {
        $(evt.target).parent('.prisma-input-group').toggleClass('focused', false);
    },

    onFocusInput(evt) {
        $(evt.target).parent('.prisma-input-group').toggleClass('focused', true);
    },

    closeShareSelection: function(evt) {
        this.resetReCaptcha(this.model.get('reCaptchaWidgetId'));
        toggleView.call(this, false);
        this.trackEvent($(evt.currentTarget).data('trackEventLabel'));
    },

    initLauncher: function(config) {
        Odigeo._.extend(this.opts, config);
        this.toggleLauncher(true);
        $(this.opts.launchButton).off(Odigeo.Events.click).on(Odigeo.Events.click, Odigeo._.bind(onOpenLauncher, this));
    },

    toggleLauncher: function(isActive) {
        $(this.opts.launchButton).toggleClass('odf-hidden', !isActive);
    },
});
